function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from 'react';
import { HeaderNews } from '../HeaderNews';
import { AgroHeaderContext } from '../../contexts/AgroHeaderContext';
import PropTypes from 'prop-types';
import withCssProps from '../../hocs/withCssProps';
import { getLanguage } from '../AgroHeader/getLanguage';
var AgroHeaderNews = withCssProps(function (_ref) {
  var _ref$baseUrl = _ref.baseUrl,
    baseUrl = _ref$baseUrl === void 0 ? 'https://news.agrofy.com.ar' : _ref$baseUrl,
    _ref$marketUrl = _ref.marketUrl,
    marketUrl = _ref$marketUrl === void 0 ? 'https://www.agrofy.com.ar' : _ref$marketUrl,
    loginUrlRedirect = _ref.loginUrlRedirect,
    logoutFunction = _ref.logoutFunction,
    _ref$language = _ref.language,
    language = _ref$language === void 0 ? 'es-AR' : _ref$language,
    tagManager = _ref.tagManager,
    apiGateway = _ref.apiGateway,
    _suggestionCallback = _ref.suggestionCallback,
    _ref$user = _ref.user,
    user = _ref$user === void 0 ? null : _ref$user,
    notifications = _ref.notifications,
    _ref$loadingUser = _ref.loadingUser,
    loadingUser = _ref$loadingUser === void 0 ? false : _ref$loadingUser,
    _ref$loadingNotificat = _ref.loadingNotifications,
    loadingNotifications = _ref$loadingNotificat === void 0 ? false : _ref$loadingNotificat,
    _ref$location = _ref.location,
    location = _ref$location === void 0 ? true : _ref$location,
    onClick = _ref.onClick,
    _ref$menuSection = _ref.menuSection,
    menuSection = _ref$menuSection === void 0 ? '' : _ref$menuSection,
    _ref$urlMenuService = _ref.urlMenuService,
    urlMenuService = _ref$urlMenuService === void 0 ? null : _ref$urlMenuService,
    _ref$urlSearchService = _ref.urlSearchService,
    urlSearchService = _ref$urlSearchService === void 0 ? null : _ref$urlSearchService,
    _ref$urlPrefix = _ref.urlPrefix,
    urlPrefix = _ref$urlPrefix === void 0 ? '' : _ref$urlPrefix,
    _ref$popoverDisabled = _ref.popoverDisabled,
    popoverDisabled = _ref$popoverDisabled === void 0 ? false : _ref$popoverDisabled,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'full' : _ref$variant,
    onLastLocationChanged = _ref.onLastLocationChanged,
    _ref$lastLocation = _ref.lastLocation,
    lastLocation = _ref$lastLocation === void 0 ? null : _ref$lastLocation,
    mainMenuUrl = _ref.mainMenuUrl,
    _ref$mainMenuVersion = _ref.mainMenuVersion,
    mainMenuVersion = _ref$mainMenuVersion === void 0 ? '1' : _ref$mainMenuVersion,
    _ref$pageId = _ref.pageId,
    pageId = _ref$pageId === void 0 ? null : _ref$pageId,
    _ref$ctaCurrentLocati = _ref.ctaCurrentLocationLabelModal,
    ctaCurrentLocationLabelModal = _ref$ctaCurrentLocati === void 0 ? null : _ref$ctaCurrentLocati,
    _ref$openLocationModa = _ref.openLocationModal,
    openLocationModal = _ref$openLocationModa === void 0 ? {
      value: false
    } : _ref$openLocationModa,
    onLocationModalClose = _ref.onLocationModalClose,
    _ref$categoryId = _ref.categoryId,
    categoryId = _ref$categoryId === void 0 ? null : _ref$categoryId;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    level = _useState2[0],
    setLevel = _useState2[1];
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    accountMenu = _useState4[0],
    setAccountMenu = _useState4[1];
  var translations = getLanguage(language);
  var clasifyItems = [{
    title: '',
    itemsToFilter: [translations.firstLevelMenu.enter]
  }, {
    title: translations.firstLevelMenu.sales,
    itemsToFilter: [translations.firstLevelMenu.publish, translations.firstLevelMenu.buyNotices]
  }, {
    title: translations.firstLevelMenu.purchases,
    itemsToFilter: [translations.firstLevelMenu.sections, translations.firstLevelMenu.highlightedOffers, translations.firstLevelMenu.rankings]
  }];
  var _useState5 = useState([clasifyItems]),
    _useState6 = _slicedToArray(_useState5, 2),
    clasifyItemLocal = _useState6[0],
    setClasifyItemsLocal = _useState6[1];
  var _useState7 = useState({}),
    _useState8 = _slicedToArray(_useState7, 2),
    sessionItem = _useState8[0],
    setSessionItem = _useState8[1];
  var resetClasifyItems = function resetClasifyItems() {
    setLevel(0);
  };
  var context = {
    baseUrl: baseUrl,
    marketUrl: marketUrl,
    sessionItem: sessionItem,
    setSessionItem: setSessionItem,
    variant: variant,
    accountMenu: accountMenu,
    setAccountMenu: setAccountMenu,
    resetClasifyItems: resetClasifyItems,
    level: level,
    setLevel: setLevel,
    clasifyItems: clasifyItemLocal,
    setClasifyItems: setClasifyItemsLocal,
    loginUrlRedirect: loginUrlRedirect,
    logoutFunction: logoutFunction,
    language: language,
    tagManager: tagManager,
    apiGateway: apiGateway,
    user: user,
    loadingUser: loadingUser,
    loadingNotifications: loadingNotifications,
    location: location,
    onClick: onClick,
    notifications: notifications,
    menuSection: menuSection,
    urlMenuService: urlMenuService,
    urlSearchService: urlSearchService,
    translations: translations,
    suggestionCallback: function suggestionCallback(text) {
      return _suggestionCallback(text);
    },
    urlPrefix: urlPrefix,
    popoverDisabled: popoverDisabled,
    onLastLocationChanged: onLastLocationChanged,
    lastLocation: lastLocation,
    mainMenuUrl: mainMenuUrl,
    mainMenuVersion: mainMenuVersion,
    pageId: pageId,
    ctaCurrentLocationLabelModal: ctaCurrentLocationLabelModal,
    openLocationModal: openLocationModal,
    onLocationModalClose: onLocationModalClose,
    categoryId: categoryId
  };
  return /*#__PURE__*/React.createElement(AgroHeaderContext.Provider, {
    value: context
  }, /*#__PURE__*/React.createElement(HeaderNews, null));
});
AgroHeaderNews.propTypes = {
  baseUrl: PropTypes.string,
  tagManager: PropTypes.func,
  apiGateway: PropTypes.string,
  suggestionCallback: PropTypes.func,
  searchSubmit: PropTypes.func,
  logoutFunction: PropTypes.func,
  user: PropTypes.object,
  notifications: PropTypes.object,
  loadingUser: PropTypes.bool,
  loadingNotifications: PropTypes.bool,
  location: PropTypes.bool,
  onClick: PropTypes.func,
  language: PropTypes.string.isRequired,
  urlMenuService: PropTypes.string,
  urlSearchService: PropTypes.string,
  variant: PropTypes.oneOf(['default', 'full']),
  clasifyItems: PropTypes.array,
  clasify: PropTypes.bool,
  setClasify: PropTypes.func,
  onLastLocationChanged: PropTypes.func,
  lastLocation: PropTypes.object,
  urlPrefix: PropTypes.string,
  mainMenuUrl: PropTypes.string,
  mainMenuVersion: PropTypes.string,
  pageId: PropTypes.string,
  ctaCurrentLocationLabelModal: PropTypes.string,
  openLocationModal: PropTypes.object,
  onLocationModalClose: PropTypes.func
};
AgroHeaderNews.displayName = 'AgroHeaderNews';
export { AgroHeaderNews };